<template>

    <!-- <div class='justify-center row'> -->

        <div class="legend-container q-mb-sm">
            <div class="legend-title row no-wrap justify-between q-headline text-white items-center q-pa-sm">
                <div class='gt-xs'>готовность:  {{readyCount}} из {{number}} </div>
                <div class='lt-sm q-body-1 row justify-center items-center'>готовность: {{readyCount}} из {{number}} </div>
                <q-btn v-if="!legendVisible" icon='keyboard_arrow_right' flat  @click="legendVisible = !legendVisible" class='gt-sm'/>
                <q-btn v-if="legendVisible" icon='keyboard_arrow_down' flat  @click="legendVisible = !legendVisible" class='gt-sm'/>
                <!-- есть маленькое разрешение -->
                <q-btn v-if="!legendVisible" icon='keyboard_arrow_right' flat dense  @click="legendVisible = !legendVisible" class='lt-md'/>
                <q-btn v-if="legendVisible" icon='keyboard_arrow_down' flat dense  @click="legendVisible = !legendVisible" class='lt-md'/>

            </div>

            <q-slide-transition :duration=500>
                <div v-if="legendVisible" class='q-mt-sm'>
                    <div v-for='item in writeOffList' :key='item.id' class="writeOff-line row justify-around">
                        <span>{{getPrettyDate(item.created_at)}}</span>
                        <span>{{item.who_name}}</span>
                        <span><b>{{item.number}} шт </b></span>
                    </div>
                </div>
            </q-slide-transition>

            <div class='row full-width justify-center'>
                <q-btn v-if="showCloseButton" class='gt-xs' style="margin:15px; max-width:180px;" color="negative" label='закрыть заказ' icon="done" @click="closeOrder" :loading = 'closeLoading'/>
                <!-- если маленькое разрешение -->
                <q-btn v-if="showCloseButton" class='lt-sm' dense style="margin:15px; max-width:180px;" color="negative" label='закрыть заказ' icon="done" @click="closeOrder" :loading = 'closeLoading'/>
            </div>
        </div>

    <!-- </div> -->

</template>

<script>
/* eslint-disable */

import { date } from "quasar-framework/dist/quasar.mat.esm";

export default {
    name : 'printTerminalWriteOffLegend',
    
    data () {
            return {
                legendVisible : false,
                closeLoading : false,
            }
    },

    props : {
        orderId : {
            type : Number,
            required : true, 
        },
        number : {
            type : Number,
            required : true,
        }
    },
    methods : {
        getPrettyDate(date) {
            let d = new Date(date);
            let offcet = d.getTimezoneOffset()/60;
            d.setHours(d.getHours()-offcet);
            return d.toLocaleString();
        },

        closeOrder() {
            //Cпрашиваем на всякий случай - действительно закрыть файл
            this.$q.dialog({
                color : 'primary',
                ok : 'Да, закрыть',
                cancel : 'Отмена',
                title : 'Внимание!',
                message:'Вы действительно хотите закрыть заказ?'
            })
            .then( ()=> {
                this.closeLoading = true;
                this.$store.dispatch('closeFile', this.orderId)
                .then(()=>{
                    // console.log('file closed');
                    this.closeLoading = false;
                })
                .catch((error)=>{
                    this.$admns.showNotify('Ошибка при закрытии файла','error','Сообщение системы');
                    console.log(error);
                    this.closeLoading = false;
                });
            })
            .catch(()=>{});
        },
    },
    computed : {
        showCloseButton() {
           return this.$store.getters.getReadyCount(this.orderId)>=this.number;
        },

        readyCount() {
             return this.$store.getters.getReadyCount(this.orderId);
        },

        writeOffList(){

            var options = {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            };

            var list = this.$store.getters.getWriteOffByFileId(this.orderId);

            list.forEach(element => { //Делаем красивую дату
                // let d = new Date(element.created_at); // делаем приятную дату
                // element.created_at = d.toLocaleString("ru", options);
                // element.created_at = d.toLocaleString();
                var user = this.$store.getters.getUserById(element.who);
                element.who_name = '';
                if (user.name != undefined) element.who_name += user.name;
                if (user.surname != undefined) element.who_name += ' '+user.surname;
            });
            
            if (list.length > 0) {
                return list;
            }
            else return '';
            
        },

    }

}
</script>


<style lang="scss" scoped>
    .legend-container {
        border : 1px solid rgb(204, 204, 204);
        width : 100%;
    }
    .legend-title {
        background: #065baf;
    }
    .writeOff-line {
        width : 100%;
        border-bottom: 1px dotted rgb(182, 182, 182);
        min-height : 25px;
        cursor: pointer;
        font-size : 12px;
        padding:4px;
        &:hover {
            background: rgb(191, 248, 189);
        }
    }
</style>

